import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Sparklines, SparklinesLine } from 'react-sparklines';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

// Popover component using React Portal
const Popover = ({ children, position }) => {
    const popoverStyle = {
        position: 'absolute',
        top: position.top,
        left: position.left,
        width: 300,
        height: 200,
        background: 'white',
        border: '1px solid #ddd',
        padding: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
    };

    return ReactDOM.createPortal(
        <div style={popoverStyle}>{children}</div>,
        document.body
    );
};

const PriceHistoryCell = ({ sparklineData }) => {
    const [hovered, setHovered] = useState(false);
    const [popoverPos, setPopoverPos] = useState({ top: 0, left: 0 });
    const containerRef = useRef(null);

    // Prepare chart data assuming each record has a date and price.
    const chartData = sparklineData.map(record => ({
        date: record.date,
        price: record.price,
    }));

    const handleMouseEnter = () => {
        setHovered(true);
        if (containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            setPopoverPos({
                top: rect.bottom + window.scrollY + 5,
                left: rect.left + window.scrollX,
            });
        }
    };

    const handleMouseLeave = () => {
        setHovered(false);
    };

    return (
        <div
            ref={containerRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ position: 'relative' }}
        >
            <Sparklines data={sparklineData.map(record => record.price)} height={50}>
                <SparklinesLine color="blue" />
            </Sparklines>
            {hovered && (
                <Popover position={popoverPos}>
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={chartData}>
                            <XAxis
                                dataKey="date"
                                tickFormatter={dateStr => new Date(dateStr).toLocaleDateString()}
                                tick={{ fontSize: 10 }}
                                label={{ value: 'Date', position: 'insideBottom', offset: -5 }}
                            />
                            <YAxis
                                tick={{ fontSize: 10 }}
                                label={{ value: 'Price', angle: -90, position: 'insideLeft', offset: 0 }}
                            />
                            <Tooltip />
                            <Line type="monotone" dataKey="price" stroke="blue" dot={false} />
                        </LineChart>
                    </ResponsiveContainer>
                </Popover>
            )}
        </div>
    );
};

export default PriceHistoryCell;
